let TrustbarSlider = {}, isInitialized = false, $trustbarSlider, $slider, $autoplay;

TrustbarSlider = {
  init() {
    $trustbarSlider = $('.js-trustbar-slider');

    if ($trustbarSlider.length === 0) {
      return;
    }

    $.each( $trustbarSlider, function() {
      $slider = $(this);
      $autoplay = $slider.data('autoplay');

      $slider.flickity({
        autoPlay: $autoplay,
        pauseAutoPlayOnHover: false,
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        wrapAround: true,
        pageDots: true,
				dragThreshold: 10,
				imagesLoaded: true,
        on: {
          ready: function () {
            if (matchMedia('screen and (max-width: 1023px)').matches) {
              isInitialized = true;
            }
          },
        },
      });

      if (matchMedia('screen and (min-width: 1024px)').matches) {
        isInitialized = false;
      }

      if (isInitialized == false) {
        $slider.flickity('destroy');
      }
    });
  },
}

$(function () {
  TrustbarSlider.init();

  $(window).resize(function () {
    TrustbarSlider.init();
	});

});

window.TrustbarSlider = TrustbarSlider;



// WEBPACK FOOTER //
// ./scripts/components/sliders/trustbar-slider.js